<template>
    <div class="modal" id="new-role-modal">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <form id="new-role-form" @submit.prevent="createRole">
                    <div class="modal-header">
                        <h5>Nuevo rol</h5>
                        <button type="button" @click="closeModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="role-name" class="form-label">Nombre</label>
                            <input type="text" class="form-control" name="name" id="role-name" v-model="newRoleName" required>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-danger" type="button" @click="closeModal">Cancelar</button>
                        <button id="new-role-save" class="btn btn-success" type="submit">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
    name: 'RoleCreateModal',
    data() {
        return {
            newRoleName: ''
        };
    },
    methods: {
        createRole() {
            axios.post('/api/roles/create', {name: this.newRoleName})
                .then(response => {
                    showCustomSuccessSweetAlert('Rol creado correctamente');
                    this.$emit('role-created');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        closeModal() {
            this.$emit('close-modal');
        },
    }
};
</script>